import { Component, OnDestroy, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { AppealsService } from 'src/app/services/appeals.service';
import { DataService } from 'src/app/services/data.service';
import { DisclaimersService } from 'src/app/services/disclaimers.service';
import { ErrorHandlerService } from 'src/app/services/error-handler.service';

@Component({
  selector: 'app-appeals',
  templateUrl: './appeals.page.html',
  styleUrls: ['./appeals.page.scss'],
})
export class AppealsPage implements OnDestroy {
  subscriptionEvent;
  constructor(
    
    private errorSRV:ErrorHandlerService,
    public modalController: ModalController,
    public dataService: DataService,
    public appealsSRV: AppealsService,
  ) {}

  ionViewDidEnter() {
    
          this.subscriptionEvent= this.dataService.isAuthenticated.subscribe(isLoggedIn=>{
             if(isLoggedIn){
               this.appealsSRV.getViolations();
             } else {
               this.appealsSRV.loaded=false
               this.appealsSRV.violations={}
               this.ngOnDestroy()
             }
           })
         
      
    
    
    
   
  }
  ngOnDestroy() {
    if(this.subscriptionEvent){
      this.subscriptionEvent.unsubscribe()
    }
     
   }

  
  
}
